import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { createRef } from 'react'
import MaskedInput from 'react-maskedinput'

import { isSameDay, isSameUtcOffset } from './DateUtils'

class DateInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: this.safeDateFormat(this.props)
    }
    this.input = createRef()
  }

  UNSAFE_componentWillReceiveProps (newProps) {
    const st1 =
      !isSameDay(newProps.date, this.props.date) ||
      !isSameUtcOffset(newProps.date, this.props.date) ||
      newProps.locale !== this.props.locale ||
      newProps.dateFormat !== this.props.dateFormat
    const st2 =
      !this.props.disableDateAutoCorrection ||
      (newProps.date && newProps.date.isValid())

    if (st1 && st2) {
      this.setState({
        value: this.safeDateFormat(newProps)
      })
    }
  }

  handleChange = event => {
    this.handleChangeDate(event.target.value)
  }

  handleChangeDate = value => {
    const { onChangeRaw } = this.props
    onChangeRaw(value)
    this.setState({ value })
  }

  safeDateFormat = props =>
    (props.date &&
      props.date
        .clone()
        .locale(props.locale || moment.locale())
        .format(
          Array.isArray(props.dateFormat)
            ? props.dateFormat[0]
            : props.dateFormat
        )) ||
    ''

  handleBlur = event => {
    const val = this.safeDateFormat(this.props)
    if (!this.props.disableDateAutoCorrection || val !== '') {
      this.setState({
        value: val
      })
    }
    if (this.props.onBlur) {
      this.props.onBlur(event)
    }
  }

  focus = () => {
    this.input.current?.focus()
  }

  displayError = () => {
    const { error } = this.props
    if (!error) {
      return null
    }
    return (
      <span className='nh-error-span'>
        *
        {error}
      </span>
    )
  }

  render () {
    const { customInput, label, ...rest } = this.props
    const className = this.state.value || this.props.value ? 'valid' : ''
    const val = this.state.value || this.props.value
    const validRestProps = _.pickBy(
      { ...rest },
      (v, k) => [ 'onCalenderOpen', 'error' ].indexOf(k) < 0
    )
    const {
      onChangeDate,
      onChangeRaw,
      dateFormat,
      filterDate,
      includeDates,
      excludeDates,
      maxDate,
      minDate,
      disableDateAutoCorrection,
      ...p
    } = validRestProps
    if (customInput) {
      return React.cloneElement(customInput, {
        ...validRestProps,
        ref: this.input,
        value: this.state.value,
        onBlur: this.handleBlur,
        onChange: this.handleChange
      })
    }
    return (
      <div className='text-container'>
        <MaskedInput
          ref={this.input}
          mask='11/11/1111'
          placeholder=''
          value={val}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          {...p}
        />
        <button
          type='button'
          onClick={this.props.onCalenderOpen}
        >
          <i className='fa fa-calendar' />
        </button>

        <span className='bar' />
        <label id={className}>{label}</label>
        {this.displayError()}
      </div>
    )
  }
}
DateInput.displayName = 'DateInput'

DateInput.propTypes = {
  customInput: PropTypes.element,
  date: PropTypes.instanceOf(Object),
  dateFormat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Array)
  ]),
  disabled: PropTypes.bool,
  disableDateAutoCorrection: PropTypes.bool,
  excludeDates: PropTypes.instanceOf(Array),
  filterDate: PropTypes.func,
  includeDates: PropTypes.instanceOf(Array),
  locale: PropTypes.string,
  maxDate: PropTypes.instanceOf(Object),
  minDate: PropTypes.instanceOf(Object),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onChangeRaw: PropTypes.func,
  onChangeDate: PropTypes.func,
  label: PropTypes.string,
  onCalenderOpen: PropTypes.func.isRequired
}

DateInput.defaultProps = {
  dateFormat: 'L',
  disableDateAutoCorrection: false
}

export default DateInput
